import React, { FC, useState } from 'react';

import Dropdown from 'antd/es/dropdown';
import { useTheme } from 'styled-components';

import CustomIcon from '@components/utils/CustomIcon';
import { ClockIcon } from '@assets/icons';

import {
  Wrapper,
  Container,
  StyledInput,
  IconWrapper,
  TimesWrapper,
  MenuWrapper,
} from './styled';

export interface ITimePicker {
  title: string;
  onChange: (value: string) => void;
  time: string;
  containerClassName?: string;
  availableTimes?: string[];
}

const TimePickerComp: FC<ITimePicker> = ({
  onChange,
  title,
  time,
  containerClassName,
  availableTimes,
}) => {
  const theme = useTheme();
  const [isOpenDropdown, setIsOpenDropdown] = useState(false);

  const handleTimeSelected = (selectedTime: string) => {
    onChange(selectedTime);
    setIsOpenDropdown(false);
  };

  const dropdownItems =
    availableTimes?.length === 0
      ? [
          {
            key: Math.random().toString(),
            label: (
              <TimesWrapper>
                <span>Bu tarihlerde uygun saat bulunmamaktadır.</span>
              </TimesWrapper>
            ),
          },
        ]
      : availableTimes?.map((item, i) => ({
          key: item,
          label: (
            <TimesWrapper key={i} onClick={() => handleTimeSelected(item)}>
              <span data-testid={`car-rental-searchbar-time-${item}`}>
                {item}
              </span>
            </TimesWrapper>
          ),
        }));

  return (
    <Container className={containerClassName}>
      <Wrapper>
        <Dropdown
          menu={{ items: dropdownItems }}
          placement='bottom'
          trigger={['click']}
          onOpenChange={(val) => setIsOpenDropdown(val)}
          open={isOpenDropdown}
          overlayStyle={{
            zIndex: theme.zIndices.timePicker,
          }}
          popupRender={(menu) => <MenuWrapper>{menu}</MenuWrapper>}
        >
          <div style={{ width: '100%' }}>
            <IconWrapper>
              <CustomIcon
                icon={ClockIcon}
                fontSize={24}
                paletteColor='grey500'
              />
            </IconWrapper>
            <StyledInput readOnly placeholder={title} value={time || ''} />
          </div>
        </Dropdown>
      </Wrapper>
    </Container>
  );
};

export default TimePickerComp;
